<template>
    <div v-if="show" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="nevs-popup-text">
                <div class="match-transaction-summary">
                    <div>{{ transaction.date_display }} - {{ transaction.payer_name }}</div>
                    <div><strong>{{ transaction.amount_display }}</strong></div>
                    <div>{{ transaction.reference }}</div>
                </div>
                <NevsSelect :nullable="true" :error="validation.invoice_id" v-model="invoiceId"
                            :ajax="'select/invoices-matchable/' + transaction.id"
                            :label="$LANG.Get('fields.invoice')"></NevsSelect>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">{{ $LANG.Get('buttons.cancel') }}</NevsButton>
                <NevsButton class="success" @click="saveClick()">{{ $LANG.Get('buttons.ok') }}</NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "ModalMatchTransaction",
    components: {NevsSelect, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        transaction: {
            type: Object,
            default: null
        }
    },
    emits: ['done'],
    data() {
        return {
            invoiceId: null,
            validation: {
                invoice_id: ''
            }
        }
    },
    watch: {
        show() {
            this.invoiceId = null;
            this.validation.invoice_id = '';
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        saveClick() {
            if (this.invoiceId === null) {
                this.validation.invoice_id = this.$LANG.Get('labels.mandatoryField');
                return;
            }
            this.validation.invoice_id = '';

            let vm = this;
            this.$API.APICall('post', 'transactions/match/' + this.transaction.id, {
                invoice_id: this.invoiceId
            }, (data, success) => {
                if (success) {
                    vm.$emit('done', true);
                } else {
                    // The API answers with the reason the invoice cannot take this transaction (it already has
                    // a payment, it is not paid by transfer, e-reporting failed, ...), which is a message for
                    // the person picking the invoice rather than a server error.
                    let message = vm.$LANG.Get('alerts.transactionErrors.' + data.message);
                    if (message.startsWith('alerts.')) {
                        vm.$HELPERS.HandleServerError(vm, data);
                        return;
                    }
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: message, type: 'alert'});
                }
            });
        }
    }
}
</script>

<style scoped>
.match-transaction-summary {
    margin: 5px;
    margin-bottom: 15px;
}
</style>
